import { qs, qsa, $on, debounce } from "./helpers/utils";
import { getDeviceType, getDeviceWidth } from "./helpers/deviceHelpers";
import * as CONSTANTS from "./constants/constants";
import "../stylesheets/style.scss";
import { onWindowLoad, preloadImages } from "./helpers/windowHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Splitting from "splitting";
import Odometer from "odometer";
gsap.registerPlugin(ScrollTrigger);
import SplitType from "split-type";
import barba from "@barba/core";
import LocomotiveScroll from "locomotive-scroll";
import barbaPrefetch from "@barba/prefetch";
import airMonitoringImg from "./images/monitoringSites/airMonitoring.png";
import monitoringSitesMapImg from "./images/monitoringSites/map2.svg";
import contactPhoto1Img from "./images/contact/photo1.jpg";
import contactPhoto2Img from "./images/contact/photo2.jpg";
import executiveOfficerHeadshotImg from "./images/executiveOfficer/executiveOfficerHeadshot.jpg";
import execStatementImg from "./images/executiveOfficer/execStatement.jpg";
import climatetechfinanceImg from "./images/cleanAirInitiative/Climate-tech-finance.jpg";
import vanillabear2Img from "./images/furtheringCommunity/vanilla-bear-2.jpg";
import buildingdecarbImg from "./images/cleanAirInitiative/Building-decarb.jpg";
import commutebenefitsflexcommuteImg from "./images/cleanAirInitiative/Commute-benefits-flex-commute.jpg";
import sustainableaviationfuelImg from "./images/cleanAirInitiative/Sustainable-aviation-fuel.jpg";
import wildfireresponseprogramImg from "./images/furtheringCommunity/wildfire-response-program.jpg";
import chevronrichmondImg from "./images/furtheringCommunity/chevron-richmond.jpg";
import westoaklandparkImg from "./images/furtheringCommunity/westoaklandpark.jpg";
import airfiltrationunitsImg from "./images/furtheringCommunity/air-filtration-units.jpg";
import vanillabear1Img from "./images/furtheringCommunity/vanilla-bear-1.jpg";
import stateCapitolimage1Img from "./images/stateCapitol/image1.jpg";
import statecapImg from "./images/stateCapitol/state-cap.jpg";
import numbersphoto1Img from "./images/theNumbers/numbers-photo1.jpg";
import airmonitoringImg2 from "./images/theNumbers/air-monitoring.jpg";
import numbersphoto2Img from "./images/theNumbers/numbers-photo2.jpg";
import numbersphoto3Img from "./images/theNumbers/numbers-photo3.jpg";
import airDistrictimageImg from "./images/airDistrict/image.jpg";

import gif1 from "./images/gifs/CleanCarsforAllvideo.jpg";
import gif2 from "./images/gifs/ClimateTechFinanceProgramvideo.jpg";
import gif3 from "./images/gifs/CommunityAdvisoryCouncilvideo.jpg";
import gif4 from "./images/gifs/Rule6-5video.jpg";
import gif5 from "./images/gifs/WildfireAirQualityResponsevideo.jpg";

window.odometerOptions = {
  auto: false, //Don't automatically initialize everything with class 'odometer',
  duration: 700,
};

const init = () => {
  //hide loader
  let pageLoader = qs(".page-loader");
  gsap
    .timeline({
      delay: 1,
    })
    .to(pageLoader, {
      duration: 0.2,
      ease: "easeInOutQuart",
      opacity: 0.8,
    })
    .set(pageLoader, {
      display: "none",
    });
  //start prefetching

  //checking if it IE then redirect
  const detectIE = () => {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    var trident = ua.indexOf("Trident/");
    if (msie > 0 || trident > 0) {
      document.location = "/browser-not-supported.html";
    }
    // other browser
    else return false;
  };

  let urlArray = document.location.href.split("/");
  if (urlArray[3] !== "browser-not-supported.html") {
    detectIE();
  }

  preloadImages([
    airMonitoringImg,
    monitoringSitesMapImg,
    contactPhoto1Img,
    contactPhoto2Img,
    executiveOfficerHeadshotImg,
    execStatementImg,
    climatetechfinanceImg,
    vanillabear2Img,
    buildingdecarbImg,
    commutebenefitsflexcommuteImg,
    sustainableaviationfuelImg,
    wildfireresponseprogramImg,
    chevronrichmondImg,
    westoaklandparkImg,
    airfiltrationunitsImg,
    vanillabear1Img,
    stateCapitolimage1Img,
    statecapImg,
    numbersphoto1Img,
    airmonitoringImg2,
    numbersphoto2Img,
    numbersphoto3Img,
    airDistrictimageImg,
    gif1,
    gif2,
    gif3,
    gif4,
    gif5,
  ]);
  //end

  // main init fn
  let logoBlack = qs(".brand-logo .logo_black");
  let logoWhite = qs(".brand-logo .logo_white");
  let burgerMenu = qs(".burger-menu .burger-menu-svg");
  let navWrapper = qs(".nav-wrapper");
  let navWrapperMenuLink = qsa(".nav-wrapper ul li a");
  let navWrapperPDFLink = qs(".nav-wrapper a.download-link");
  let logoHeader = qs(".header-wrapper");
  let colorStripesMobile = qs(".color-strips-wrapper-mobile");
  let bodyEle = document.body; //IE 'quirks'
  let documentEle = document.documentElement; //IE with doctype
  documentEle = documentEle.clientHeight ? documentEle : bodyEle;
  let menuOpenTimeline = null;
  let menuCloseTimeline = null;
  let menuStripHideTimeline = null;
  let isDesktopMenuStripsHidden = false;
  let isDesktopMenuStripsWasHidden = false;
  let cyanStrip = qs(".color-strip.bg-color-cyan");
  let blueStrip = qs(".color-strip.bg-color-blue");
  let darkBlueStrip = qs(".color-strip.bg-color-dark-blue");
  let purpleStrip = qs(".color-strip.bg-color-purple");
  let yellowStrip = qs(".color-strip.bg-color-yellow");
  let orangeStrip = qs(".color-strip.bg-color-orange");
  let redStrip = qs(".color-strip.bg-color-red");
  let creamStrip = qs(".color-strip.bg-color-cream");
  let otherStips = qsa(".color-strip:not(.bg-color-cyan)");
  let allStips = qsa(".color-strip");
  let container = qs(".color-strips-wrapper");
  let containerForMobile = qs(".color-strips-wrapper-mobile");
  let scrollElement = null;
  let scroll = null;
  let youtubeVideoContainer = qs(".landing-video-player");
  let pageSpeechTitleBlock = qs(".page-title-block");
  let linksInColorStrip = qsa(".color-strips-wrapper-landing a");
  let isClickedOnStripLink = false;
  let videoCloseAnim = () => {};
  let scrollerParam = { scroller: "[data-scroll-container]" };
  if (
    getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
    getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
  ) {
    scrollerParam = {};
  }

  let indexLink = false;

  const indexLinkClickPreventWhileAnimating = () => {
    indexLink = qsa("a[href='/index.html']");

    const linkClickfn = (e) => {
      if (
        (!!menuCloseTimeline && menuCloseTimeline.isActive()) ||
        (!!menuOpenTimeline && menuOpenTimeline.isActive()) ||
        (!!menuStripHideTimeline && menuStripHideTimeline.isActive())
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };

    !!indexLink &&
      indexLink.forEach((link) => {
        $on(link, "click", linkClickfn);
      });
  };

  indexLinkClickPreventWhileAnimating();

  const footerlinkRedirectionMobile = (e, link) => {
    let htmlEle = qs("html");
    let styleObj = window.getComputedStyle(htmlEle);
    let styleObjScroll = styleObj.getPropertyValue("scroll-behavior");
    if (styleObjScroll === "smooth") {
      htmlEle.style.scrollBehavior = "auto";
      e.preventDefault();
      e.stopImmediatePropagation();
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "auto",
        });
      }, 50);
      setTimeout(() => {
        link.click();
        link.removeEventListener("click", (e) =>
          footerlinkRedirectionMobile(e, link)
        );
      }, 60);
    } else {
      htmlEle.style.scrollBehavior = "smooth";
    }
  };

  const footerlinkRedirectionMobileInit = () => {
    let allLink = qsa(".footer .prev_btn a, .footer .next_btn a");
    !!allLink &&
      allLink.forEach((link) => {
        $on(link, "click", (e) => footerlinkRedirectionMobile(e, link));
      });
  };

  barba.use(barbaPrefetch);
  barba.init({
    transitions: [
      {
        name: "custom-landing-transition",
        to: {
          namespace: ["landing"],
        },
        enter() {
          youtubeVideoContainer = qs(".landing-video-player");
          return gsap.set(youtubeVideoContainer, { opacity: 0 });
        },
      },
    ],
    views: [
      {
        namespace: "landing",
        beforeEnter() {
          stripsShowAniation(0);
          isDesktopMenuStripsWasHidden = false;
          if (colorStripesMobile.classList.contains("below-menu")) {
            colorStripesMobile.classList.remove("below-menu");
          }
        },
        afterEnter(d) {
          landingInit(d.next.namespace);
        },
        beforeLeave() {
          if (!colorStripesMobile.classList.contains("below-menu")) {
            colorStripesMobile.classList.add("below-menu");
          }
          logoHeader.classList.remove("white_bg_likelook", "bg-white");
        },
      },
      {
        namespace: "executive-officer-statement",
        beforeEnter() {
          // hide burger menu
        },
        afterEnter(d) {
          // only one fn will be called from here
          executiveOfficerStatementInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("white_bg_likelook", "bg-color-cyan");
          burgerMenu.classList.remove("white-hover");
        },
      },
      {
        namespace: "monitoring-sites",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          monitoringSitesInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("dark_bg_likelook", "bg-color-blue");
        },
      },
      {
        namespace: "furthering-community-protections",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          furtheringCommunityInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("dark_bg_likelook", "bg-color-dark-blue");
        },
      },
      {
        namespace: "forwarding-clean-air-initiatives",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          forwardingCleanAirInitiativesInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("dark_bg_likelook", "bg-color-purple");
        },
      },
      {
        namespace: "the-numbers",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          theNumbersInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("white_bg_likelook", "bg-color-yellow");
        },
      },
      {
        namespace: "state-capitol",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          stateCapitolInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("white_bg_likelook", "bg-color-orange");
        },
      },
      {
        namespace: "air-district",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          airDistrictInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("white_bg_likelook", "bg-color-red");
        },
      },
      {
        namespace: "contact",
        beforeEnter() {},
        afterEnter(d) {
          // only one fn will be called from here
          contactInit(d.next.namespace);
        },
        beforeLeave() {
          logoHeader.classList.remove("white_bg_likelook", "bg-color-cream");
        },
      },
    ],
  });

  const toggleMenu = (namespace = "") => {
    if (burgerMenu.classList.contains("active")) {
      if (!!menuOpenTimeline && menuOpenTimeline.isActive()) {
        return;
      }

      //remove tabindex
      navWrapperMenuLink.forEach((link) => {
        link.setAttribute("tabindex", "-1");
      });
      navWrapperPDFLink.setAttribute("tabindex", "-1");

      stripsHideAnimation(namespace);
      burgerMenu.classList.remove("active");
      setTimeout(() => {
        logoHeader.classList.remove("white_menu_bg");
      }, 100);

      let navWrapperPosition = {
        left: "-5vw",
      };
      let navWrapperWidth = {
        width: "0vw",
      };
      let bodyScroll = {
        position: "static",
      };

      if (CONSTANTS.WIDTH_LG >= getDeviceWidth()) {
        bodyScroll = {};
      }

      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        let urlArray = window.location.href.split("/");

        if (
          urlArray.length === 3 ||
          !urlArray[3] ||
          urlArray[3] === "#" ||
          urlArray[3] === "index.html"
        ) {
          let topPositionOfEle =
            colorStripesMobile.getBoundingClientRect().top + window.scrollY;
          navWrapperPosition = {
            height: `0`,
            top: topPositionOfEle,
          };
          navWrapperWidth = {
            width: "100vw",
          };
        } else {
          navWrapperPosition = {
            top: "115vw",
            height: `0`,
          };
          navWrapperWidth = {
            width: "100vw",
          };
        }
      }

      menuCloseTimeline = gsap
        .timeline({})
        .set(navWrapper, { overflow: "hidden" })
        .to(navWrapperMenuLink, {
          duration: 0.2,
          opacity: 0,
        })
        .to(
          navWrapperPDFLink,
          {
            duration: 0.2,
            opacity: 0,
          },
          "-=0.2"
        )
        .to(navWrapper, {
          duration: 0.5,
          ...navWrapperWidth,
          ...navWrapperPosition,
        })
        .set(qs("body"), bodyScroll);
    } else {
      if (!!menuCloseTimeline && menuCloseTimeline.isActive()) {
        return;
      }
      if (
        window.getComputedStyle(container).getPropertyValue("right") !== "0px"
      ) {
        return;
      }

      //add tabindex
      navWrapperMenuLink.forEach((link) => {
        link.setAttribute("tabindex", "0");
      });
      navWrapperPDFLink.setAttribute("tabindex", "0");

      stripsShowAniation();
      burgerMenu.classList.add("active");

      setTimeout(() => {
        logoHeader.classList.add("white_menu_bg");
      }, 100);

      let navWrapperWidth = {
        width: "60vw",
      };
      let navWrapperPosition = {};
      let bodyScroll = {
        position: "fixed",
      };
      if (CONSTANTS.WIDTH_LG >= getDeviceWidth()) {
        bodyScroll = {};
      }
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        window.scrollTo(0, 0);
        let urlArray = window.location.href.split("/");
        if (
          urlArray.length === 3 ||
          !urlArray[3] ||
          urlArray[3] === "#" ||
          urlArray[3] === "index.html"
        ) {
          let topPositionOfEle =
            colorStripesMobile.getBoundingClientRect().top + window.scrollY;
          navWrapperPosition = {
            // bottom: topPositionOfEle,
            height: `0`,
            top: topPositionOfEle,
            width: "100vw",
            left: 0,
          };
          navWrapperWidth = {
            //width: "100vw",
            height: `${topPositionOfEle}px`,
          };
        } else {
          navWrapperPosition = {
            top: "115vw",
            width: "100vw",
            height: `0`,
            left: 0,
          };
          navWrapperWidth = {
            //width: "100vw",
            height: `115vw`,
          };
        }
      }

      menuOpenTimeline = gsap
        .timeline({})
        .set(navWrapper, { overflow: "hidden" })
        .to(navWrapper, { duration: 0, ...navWrapperPosition })
        .to(navWrapper, { duration: 0.2, ...navWrapperWidth, left: 0, top: 0 })
        .set(qs("body"), bodyScroll)
        .to(navWrapperMenuLink, {
          duration: 0.1,
          opacity: 1,
        })
        .from(menuLinksSplit.lines, {
          duration: 0.4,
          ease: "easeInOutQuart",
          y: 140,
          stagger: 0.05,
        })
        .from(
          navWrapperPDFLink,
          {
            duration: 0.5,
            ease: "easeInOutQuart",
            y: 140,
          },
          "-=0.2"
        )
        .to(
          navWrapperPDFLink,
          {
            duration: 0.3,
            opacity: 1,
          },
          "-=0.2"
        )
        .set(navWrapper, { overflow: "auto" });
    }
  };

  const commonSetup = () => {
    //same route link click prevention
    let allLinks = document.getElementsByTagName("a");
    for (let i = 0, len = allLinks.length; i < len; i++) {
      allLinks[i].onclick = function (e) {
        if (e.currentTarget.href === window.location.href) {
          e.preventDefault();
          e.stopPropagation();
          if (burgerMenu.classList.contains("active")) {
            toggleMenu();
          }
        }
      };
    }

    //changing logo to white if its mobile device
    if (
      getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
      getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
    ) {
      !!logoBlack && logoBlack.classList.remove("visible");
      !!logoWhite && logoWhite.classList.add("visible");
    }

    //burger menu event listeners
    !!burgerMenu && $on(burgerMenu, "click", toggleMenu);
    !!burgerMenu &&
      $on(burgerMenu, "keydown", (e) => {
        if (e.key === "Enter") {
          toggleMenu();
        }
      });

    //hiding links for other pages
    linksInColorStrip.forEach((link) => {
      $on(link, "click", (e) => {
        isClickedOnStripLink = true;
        linksInColorStrip.forEach((link) => {
          if (
            !(
              getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
              getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
            )
          ) {
            link.style.display = "none";
          }
        });
      });
    });

    //remove tabindex
    navWrapperMenuLink.forEach((link) => {
      link.setAttribute("tabindex", "-1");
    });
    navWrapperPDFLink.setAttribute("tabindex", "-1");
  };

  commonSetup();

  const landingInit = (namespace) => {
    linksInColorStrip.forEach((link) => {
      if (
        !(
          getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
          getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
        )
      ) {
        link.style.display = "none";
      } else {
        link.style.display = "flex";
      }
    });
    let styleObj = window.getComputedStyle(burgerMenu);
    let styleObjOpacity = styleObj.getPropertyValue("opacity");
    if (styleObjOpacity == "0") {
      gsap
        .timeline({
          delay: 0.5,
          autoRemoveChildren: true,
        })
        .set(burgerMenu, {
          y: -150,
          opacity: 0,
        })
        .to(
          burgerMenu,
          {
            duration: 0.4,
            y: 0,
          },
          "0.1"
        )
        .to(
          burgerMenu,
          {
            duration: 0.4,
            opacity: 1,
          },
          "0.3"
        );
    }

    onYoutubeVideoClose();
    burgerMenu.classList.remove("dark-hover");
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        gsap.set(colorStripesMobile, { display: "flex" });
        gsap.set(colorStripesMobile, { opacity: 1 });
      }
    }, 10);
  };

  const executiveOfficerStatementInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("white_bg_likelook", "bg-color-cyan");
      }
    }, 100);
  };

  const monitoringSitesInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("dark_bg_likelook", "bg-color-blue");
      } else {
        logoHeader.classList.add("dark_bg_likelook");
      }
    }, 400);
  };

  const furtheringCommunityInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("dark_bg_likelook", "bg-color-dark-blue");
      } else {
        logoHeader.classList.add("dark_bg_likelook");
      }
    }, 100);
  };

  const theNumbersInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("white_bg_likelook", "bg-color-yellow");
      } else {
        logoHeader.classList.add("white_bg_likelook");
      }
    }, 100);
  };

  const stateCapitolInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("white_bg_likelook", "bg-color-orange");
      } else {
        logoHeader.classList.add("white_bg_likelook");
      }
    }, 100);
  };

  const airDistrictInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("white_bg_likelook", "bg-color-red");
      } else {
        logoHeader.classList.add("white_bg_likelook");
      }
    }, 100);
  };

  const contactInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("white_bg_likelook", "bg-color-cream");
      } else {
        logoHeader.classList.add("white_bg_likelook");
      }
    }, 100);
  };

  const forwardingCleanAirInitiativesInit = (namespace) => {
    afterEnterOfNextPage(namespace);
    setTimeout(() => {
      initiateLocomotive();
      if (
        getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
        getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
      ) {
        logoHeader.classList.add("dark_bg_likelook", "bg-color-purple");
      } else {
        logoHeader.classList.add("dark_bg_likelook");
      }
    }, 100);
  };

  const afterEnterOfNextPage = (namespace) => {
    //making link colored for same page
    let urlArray = document.location.href.split("/");

    if (
      urlArray[3] === "index.html" ||
      urlArray[3] === "" ||
      urlArray[3] === "#"
    ) {
      navWrapperMenuLink.forEach((link) => {
        link.classList.remove("color-cyan-f");
      });
    } else {
      document.removeEventListener("click", videoCloseAnim);
      linksInColorStrip.forEach((link) => {
        link.style.display = "none";
      });
      navWrapperMenuLink.forEach((link) => {
        if (link.getAttribute("href") === `./${urlArray[3]}`) {
          link.classList.add("color-cyan-f");
        } else {
          link.classList.remove("color-cyan-f");
        }
      });
    }

    //initializing footer link clck
    footerlinkRedirectionMobileInit();

    let animationWaitInterval;

    if (isClickedOnStripLink) {
      stripsHideAnimation(namespace);
    }
    // on click of link in strip

    animationWaitInterval = setInterval(() => {
      if (!(!!menuOpenTimeline && menuOpenTimeline.isActive())) {
        clearInterval(animationWaitInterval);

        if (namespace === "executive-officer-statement") {
          if (!burgerMenu.classList.contains("white-hover")) {
            burgerMenu.classList.add("white-hover");
          }
          //initiaitng aniamtions on load and when not transitioned from other page
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              executiveOfficerAnimations();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                executiveOfficerAnimations();
              }, 200);
            }
          }
        }

        if (namespace === "monitoring-sites") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              monitoringSitesAniamtion();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                monitoringSitesAniamtion();
              }, 200);
            }
          }
        }

        if (namespace === "furthering-community-protections") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              furtheringCommunityAniamtion();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                furtheringCommunityAniamtion();
              }, 200);
            }
          }
        }

        if (namespace === "forwarding-clean-air-initiatives") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              forwardingCleanAirAnimation();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                forwardingCleanAirAnimation();
              }, 200);
            }
          }
        }

        if (namespace === "the-numbers") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              theNumbersAnimation();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                theNumbersAnimation();
              }, 200);
            }
          }
        }

        if (namespace === "state-capitol") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              stateCapitolAnimation();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                stateCapitolAnimation();
              }, 200);
            }
          }
        }

        if (namespace === "air-district") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              airDistrictAnimation();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                airDistrictAnimation();
              }, 200);
            }
          }
        }

        if (namespace === "contact") {
          //initiaitng aniamtions on load and when not transitioned from other page stripshideanimtion only works on desktop
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            if (!burgerMenu.classList.contains("active")) {
              gsap.set(containerForMobile, { display: "none" });
            }
            setTimeout(() => {
              contactAnimation();
            }, 200);
          } else if (!burgerMenu.classList.contains("active")) {
            if (!isClickedOnStripLink) {
              if (
                !(
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
                  getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
                )
              ) {
                gsap
                  .timeline()
                  .set(container, { width: "0vw" })
                  .set(allStips, { width: "0vw" });
              }
              setTimeout(() => {
                contactAnimation();
              }, 200);
            }
          }
        }

        //if it is landing or other page
        if (namespace === "landing") {
          youtubeVideoContainer = qs(".landing-video-player");
          if (burgerMenu.classList.contains("active")) {
            toggleMenu(namespace);
            gsap.to(youtubeVideoContainer, {
              delay: 1,
              duration: 0.5,
              opacity: 1,
            });
          } else {
            gsap.to(youtubeVideoContainer, {
              duration: 0.5,
              opacity: 1,
            });
          }
        } else {
          isDesktopMenuStripsWasHidden = true;
          if (burgerMenu.classList.contains("active")) {
            toggleMenu(namespace);
          } else {
            isDesktopMenuStripsHidden = true;
          }

          //showing page-title-block
          pageSpeechTitleBlock = qs(".page-title-block");
          if (
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          ) {
            gsap.to(pageSpeechTitleBlock, {
              duration: 0.4,
              opacity: 1,
            });
          } else {
            gsap.to(pageSpeechTitleBlock, {
              duration: 1.8,
              opacity: 1,
            });
          }
        }

        if (isClickedOnStripLink) {
          isClickedOnStripLink = false;
        }
      }
    }, 200);
  };

  const initiateLocomotive = () => {
    scrollElement = document.querySelector("[data-scroll-container]");

    if (!!scroll) {
      scroll.destroy();
    }

    if (scrollElement) {
      scroll = new LocomotiveScroll({
        el: scrollElement,
        smooth: true,
        getDirection: true,
      });
    }

    scroll && scroll.on("scroll", ScrollTrigger.update);
    if (scroll) {
      scroll.on("scroll", ScrollTrigger.update);
      ScrollTrigger.scrollerProxy("[data-scroll-container]", {
        scrollTop(value) {
          return arguments.length
            ? scroll.scrollTo(value, 0, 0)
            : scroll.scroll.instance.scroll.y;
        },
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          };
        },
        pinType: document.querySelector("[data-scroll-container]").style
          .transform
          ? "transform"
          : "fixed",
      });

      ScrollTrigger.addEventListener("refresh", () => scroll.update());
      ScrollTrigger.refresh();
    }
  };

  const handleScrollAnimation = () => {
    //checking if it is mobile and it is on landing page

    if (
      getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
      getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
    ) {
      let urlArray = window.location.href.split("/");
      if (
        urlArray.length === 3 ||
        !urlArray[3] ||
        urlArray[3] === "#" ||
        urlArray[3] === "index.html"
      ) {
        if (documentEle.scrollTop > 30) {
          logoHeader.classList.add("white_bg_likelook", "bg-white");
        } else {
          logoHeader.classList.remove("white_bg_likelook", "bg-white");
        }
      }
    }
  };

  window.addEventListener("scroll", () => {
    handleScrollAnimation();
  });

  let menuLinksSplit = new SplitType(navWrapperMenuLink, {
    types: "lines",
    lineClass: "split-line",
  });

  const onYoutubeVideoClose = () => {
    let videoCloseBtn = qs(".landing-video-close-btn");
    let youtubeVideoContainer = qs(".landing-video-player");
    let youtubeVideoIframeContainer = qs(".landing-video-embed-container");
    let landingHeadingBox = qs(".landing-heading-div");
    let landingHeadingBoxH1 = qs(".landing-heading-div h1");
    let landingHeadingBoxH4 = qs(".landing-heading-div h2");

    let h1Split = new SplitType(landingHeadingBoxH1, {
      types: "lines,words,chars",
      lineClass: "split-line",
    });

    let h4Split = new SplitType(landingHeadingBoxH4, {
      types: "lines,words,chars",
      lineClass: "split-line",
    });

    videoCloseAnim = (e) => {
      document.removeEventListener("click", videoCloseAnim);
      videoCloseAnim = () => {};
      let urlArray = document.location.href.split("/");
      if (
        urlArray[3] !== "index.html" &&
        urlArray[3] !== "" &&
        urlArray[3] !== "#"
      ) {
        return;
      }

      setTimeout(() => {
        youtubeVideoContainer = qs(".landing-video-player");
        !!youtubeVideoContainer &&
          youtubeVideoContainer.parentNode.removeChild(youtubeVideoContainer);
      }, 700);

      gsap.to(videoCloseBtn, {
        duration: 0.2,
        opacity: 0,
      });

      gsap
        .timeline({
          delay: 0.2,
          autoRemoveChildren: true,
        })
        .to(youtubeVideoIframeContainer, { duration: 0.1, opacity: 0 })
        .to(
          youtubeVideoContainer,
          {
            duration: 0.3,
            scale: 0,
            background: "rgba(0,0,0,0)",
          },
          0.1
        )
        .set(youtubeVideoContainer, {
          display: "none",
        })
        .to(
          landingHeadingBox,
          {
            duration: 0.3,
            opacity: 1,
          },
          "0.3"
        )
        .to(
          landingHeadingBox,
          {
            duration: 0.3,
            keyframes: {
              scale: [0, 0.7, 0.8, 0.9, 1.02, 1.04, 1.02, 1.01, 1],
              borderRadius: [
                "4% 2% 4% 2% / 39% 48% 31% 43%",
                "6% 5% 4% 6% / 39% 48% 31% 43%",
                "5% 2% 4% 5% / 39% 48% 31% 43%",
                "4.6% 5% 4% 4.6% / 39% 48% 31% 43%",
                "3% 2% 4% 3% / 39% 48% 31% 43%",
                "2% 1% 2% 2% / 39% 48% 31% 43%",
                "0",
              ],
            },
          },
          "-=0.3"
        )
        .set(landingHeadingBoxH1, {
          opacity: 1,
        })
        .from(
          h1Split.words,
          {
            duration: 0.8,
            ease: "easeInOutQuart",
            y: 140,
            stagger: 0.1,
          },
          "-=0.2"
        )
        .set(landingHeadingBoxH4, {
          opacity: 1,
        })
        .from(
          h4Split.words,
          {
            duration: 0.8,
            ease: "easeInOutQuart",
            y: 100,
            stagger: 0.1,
          },
          "-=0.5"
        );

      if (
        urlArray[3] === "index.html" ||
        urlArray[3] === "" ||
        urlArray[3] === "#"
      ) {
        if (
          !(
            getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
            getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
          )
        ) {
          linksInColorStrip.forEach((link) => {
            link.style.opacity = "0";
            link.style.display = "flex";
          });
          gsap.to(linksInColorStrip, {
            delay: 0.7,
            duration: 0.6,
            stagger: 0.1,
            opacity: 1,
          });
        }
      }
    };

    !!videoCloseBtn && $on(document, "click", videoCloseAnim);
    !!videoCloseBtn &&
      $on(document, "keydown", (e) => {
        if (e.key === "Enter" || e.key === "Escape") {
          videoCloseAnim();
        }
      });
  };

  const animateFooter = () => {
    let footerAddress = qsa(".ft-address p");
    let footerLinks = qsa(".ft-links a, .ft-links span");

    gsap
      .timeline({
        delay: 0.2,
        scrollTrigger: {
          trigger: footerAddress[0],
          start: "top bottom",
          scroller: "[data-scroll-container]",
        },
      })
      .from(footerAddress, {
        duration: 0.6,
        ease: "easeInOutQuart",
        stagger: 0.4,
        opacity: 0.8,
        clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
      })
      .from(footerLinks, {
        duration: 0.6,
        ease: "easeInOutQuart",
        stagger: 0.1,
        opacity: 0,
        y: 100,
      });
  };

  const executiveOfficerAnimations = () => {
    let executiveQuote = qsa(".executive-quote h2 span");

    gsap
      .timeline({
        delay: 0.1,
        autoRemoveChildren: true,
      })
      .to(executiveQuote, {
        duration: 0.6,
        ease: "easeInOutQuart",
        stagger: 0.02,
        opacity: 1,
        y: 0,
      });

    const executiveInfoSplit = Splitting({
      target: qs(".executive-info"),
      by: "lines",
    });

    const executiveWordsSplit = Splitting({
      target: qsa(".executive-words p"),
      by: "lines",
    });

    gsap
      .timeline({})
      .to(qs(".executive-info"), {
        duration: 0.6,
        ease: "easeInOutQuart",
        stagger: 0.02,
        opacity: 1,
        y: 0,
      })
      .to(qsa(".executive-words p"), {
        duration: 0.6,
        ease: "easeInOutQuart",
        stagger: 0.02,
        opacity: 1,
        y: 0,
      });

    let textToBeAniamted = [...executiveInfoSplit, ...executiveWordsSplit];

    textToBeAniamted.forEach((item) => {
      item.lines.forEach((elem) => {
        gsap
          .timeline({
            delay: 0.1,
            scrollTrigger: {
              trigger: elem,
              start: "top 90%",
              scroller: "[data-scroll-container]",
            },
          })
          .from(elem, {
            duration: 0.6,
            ease: "easeInOutQuart",
            stagger: 0.01,
            opacity: 0,
            y: 30,
          });
      });
    });

    animateFooter();
  };

  const monitoringSitesAniamtion = () => {
    setTimeout(() => {
      const animationOnText = Splitting({
        target: qsa(".animate-text"),
        by: "lines",
      });

      let animateMonitoringSites = qs(".animate-monitoring-sites");
      let animateMeteorologicalSites = qs(".animate-meteorological-sites");
      let od_animateMonitoringSites = new Odometer({
        el: animateMonitoringSites,
      });
      let od_animateMeteorologicalSites = new Odometer({
        el: animateMeteorologicalSites,
      });
      gsap
        .timeline({
          delay: 0,
          onComplete: () => {
            od_animateMonitoringSites.update(32);
            od_animateMeteorologicalSites.update(14);
          },
          scrollTrigger: {
            trigger: animateMonitoringSites,
            start: "top 90%",
            ...scrollerParam,
          },
        })
        .to(qsa(".monitoring-stats h4"), { duratio: 0.1, opacity: 1 });

      animationOnText.forEach((item, i) => {
        gsap.set(qsa(".animate-text")[i], { opacity: 1 });
        item.lines.forEach((elem) => {
          gsap
            .timeline({
              delay: 0.1,
              scrollTrigger: {
                trigger: qsa(".animate-text")[i],
                start: "top 80%",
                ...scrollerParam,
              },
            })
            .to(elem, {
              duration: 0.6,
              ease: "easeInOutQuart",
              stagger: 0.02,
              opacity: 1,
              y: 0,
            });
        });
      });

      if (!!scroll) {
        scroll.update();
      }
    }, 150);

    animateFooter();
  };

  const animateTexts = () => {
    let allAnimatingTexts = qsa(".animate-text");
    const animationOnText = Splitting({
      target: allAnimatingTexts,
      by: "lines",
    });
    animationOnText.forEach((item, i) => {
      item.lines.forEach((elem) => {
        gsap
          .timeline({
            delay: 0.1,
            scrollTrigger: {
              trigger: allAnimatingTexts[i],
              start: "top 90%",
              ...scrollerParam,
            },
          })
          .set(allAnimatingTexts[i], { opacity: 1 })
          .to(elem, {
            duration: 0.6,
            ease: "easeInOutQuart",
            stagger: 0.02,
            opacity: 1,
            y: 0,
          });
      });
    });
  };

  const animateTextsByWords = () => {
    let allAnimatingTexts = qsa(".animate-text");
    const animationOnText = Splitting({
      target: allAnimatingTexts,
      by: "lines",
    });
    animationOnText.forEach((item, i) => {
      item.words.forEach((elem) => {
        gsap
          .timeline({
            delay: 0.1,
            scrollTrigger: {
              trigger: elem,
              start: "top 95%",
              ...scrollerParam,
            },
          })
          .set(allAnimatingTexts[i], { opacity: 1 })
          .to(elem, {
            duration: 0.6,
            ease: "easeInOutQuart",
            stagger: 0.02,
            opacity: 1,
            y: 0,
          });
      });
    });
  };

  const animateBarGraph = () => {
    let rowFirstOfBarGraph = qs(".bar-graph-row-1 .color-bar");
    let rowSecondOfBarGraph = qs(".bar-graph-row-2 .color-bar");
    let rowThirdOfBarGraph = qs(".bar-graph-row-3 .color-bar");
    let rowFourthOfBarGraph = qs(".bar-graph-row-4 .color-bar");

    gsap.set(rowFirstOfBarGraph, {
      width: "0%",
    });
    gsap.set(rowSecondOfBarGraph, {
      width: "0%",
    });
    gsap.set(rowThirdOfBarGraph, {
      width: "0%",
    });
    gsap.set(rowFourthOfBarGraph, {
      width: "0%",
    });
    gsap
      .timeline({
        delay: 0.4,
        scrollTrigger: {
          trigger: qs(".bar-graph-row-1"),
          start: "top 90%",
          ...scrollerParam,
        },
      })
      .to(rowFirstOfBarGraph, {
        duration: 0.4,
        ease: "easeInOutQuart",
        width: "80%",
      })
      .to(rowFirstOfBarGraph, {
        duration: 0.5,
        ease: "easeInOutQuart",
        width: "60%",
      })
      .set(qs(".bar-graph-row-1 .color-bar p"), { display: "block" })
      .to(
        qs(".bar-graph-row-1 .color-bar p"),
        {
          duration: 0.2,
          opacity: 1,
        },
        "-=0.5"
      )
      .to(
        rowSecondOfBarGraph,
        {
          duration: 0.4,
          ease: "easeInOutQuart",
          width: "80%",
        },
        "-=0.4"
      )
      .to(rowSecondOfBarGraph, {
        duration: 0.5,
        ease: "easeInOutQuart",
        width: "100%",
      })
      .set(qs(".bar-graph-row-2 .color-bar p"), { display: "block" })
      .to(
        qs(".bar-graph-row-2 .color-bar p"),
        {
          duration: 0.2,
          opacity: 1,
        },
        "-=0.5"
      )
      .to(
        rowThirdOfBarGraph,
        {
          duration: 0.5,
          ease: "easeInOutQuart",
          width: "80%",
        },
        "-=0.4"
      )
      .to(rowThirdOfBarGraph, {
        duration: 0.5,
        ease: "easeInOutQuart",
        width: "60%",
      })
      .set(qs(".bar-graph-row-3 .color-bar p"), { display: "block" })
      .to(
        qs(".bar-graph-row-3 .color-bar p"),
        {
          duration: 0.2,
          opacity: 1,
        },
        "-=0.5"
      )
      .to(
        rowFourthOfBarGraph,
        {
          duration: 0.4,
          ease: "easeInOutQuart",
          width: "100%",
        },
        "-=0.4"
      )
      .to(rowFourthOfBarGraph, {
        duration: 0.5,
        ease: "easeInOutQuart",
        width: "90%",
      })
      .set(qs(".bar-graph-row-4 .color-bar p"), { display: "block" })
      .to(
        qs(".bar-graph-row-4 .color-bar p"),
        {
          duration: 0.2,
          opacity: 1,
        },
        "-=0.5"
      );
  };

  const animateNumber = (ele, number, setValue = false) => {
    let value = 0;
    if (setValue) {
      let num = ele.innerHTML.trim().replace(/\,/g, "").length - 1;
      value = "" + 1;
      while (num !== 0) {
        value = value + "0";
        num--;
      }
    }

    if (!ele) {
      return;
    }
    let od_ele = new Odometer({
      el: ele,
      value: Number(value),
    });

    gsap
      .timeline({
        delay: 0,
        scrollTrigger: {
          trigger: ele,
          start: "top bottom",
          ...scrollerParam,
        },
      })
      .set(ele, {
        opacity: 0,
        onComplete: () => {
          od_ele.update(number);
        },
      })
      .to(ele, { duratio: 0, delay: 0.5, opacity: 1 });
  };

  const furtheringCommunityAniamtion = () => {
    setTimeout(() => {
      animateTextsByWords();

      let animateCommMembers = qs(".animate-comm-members");
      let animateRvTravellers = qs(".animate-rv-travellers");
      let animate3M = qs(".animate-3m");

      animateNumber(animateCommMembers, 17);
      animateNumber(animateRvTravellers, 123);
      animateNumber(animate3M, 3);
      // animate-number

      animateBarGraph();

      if (!!scroll) {
        scroll.update();
      }
    }, 50);
    animateFooter();

    let playbtns = qsa(".play-video-1");
    playbtns.forEach((btn) => {
      let playbtn1Link = btn.getAttribute("srclink");
      !!btn && $on(btn, "click", () => openVideoModal(playbtn1Link));
      !!btn &&
        $on(btn, "keydown", (e) => {
          if (e.key === "Enter") {
            openVideoModal(playbtn1Link);
          }
        });
    });

    let videoPopupCloseBtn = qs(".landing-video-popup-close-btn");
    !!videoPopupCloseBtn &&
      $on(videoPopupCloseBtn, "click", () => closeVideoModal());
    !!videoPopupCloseBtn &&
      $on(videoPopupCloseBtn, "keydown", (e) => {
        if (e.key === "Enter") {
          closeVideoModal();
        }
      });
    !!videoPopupCloseBtn &&
      $on(document, "keydown", (e) => {
        if (e.key === "Escape") {
          closeVideoModal();
        }
      });
  };

  const forwardingCleanAirAnimation = () => {
    setTimeout(() => {
      let animateChargers = qs(".animate-chargers");
      let animateResidents = qs(".animate-residents");
      let animatePollutingCars = qs(".animate-polluting-cars");
      let animateTrucks = qs(".animate-trucks");
      let animateEngines = qs(".animate-engines");
      let animate505 = qs(".animate-505");
      let animate840 = qs(".animate-840");
      let animate11_3 = qs(".animate-11-3");
      let animate30 = qs(".animate-30");
      let animate76 = qs(".animate-76");

      animateNumber(animateChargers, 560);
      animateNumber(animateResidents, 2400);
      animateNumber(animatePollutingCars, 2000);
      animateNumber(animateTrucks, 30);
      animateNumber(animateEngines, 30);
      animateNumber(animate505, 505);
      animateNumber(animate840, 840);
      animateNumber(animate11_3, 11.3);
      animateNumber(animate30, 30);
      animateNumber(animate76, 76);

      animateTextsByWords();
      if (!!scroll) {
        scroll.update();
      }
    }, 50);
    animateFooter();

    let playbtns = qsa(".play-video-1");
    playbtns.forEach((btn) => {
      let playbtn1Link = btn.getAttribute("srclink");
      !!btn && $on(btn, "click", () => openVideoModal(playbtn1Link));
      !!btn &&
        $on(btn, "keydown", (e) => {
          if (e.key === "Enter") {
            openVideoModal(playbtn1Link);
          }
        });
    });

    let videoPopupCloseBtn = qs(".landing-video-popup-close-btn");
    !!videoPopupCloseBtn &&
      $on(videoPopupCloseBtn, "click", () => closeVideoModal());
    !!videoPopupCloseBtn &&
      $on(videoPopupCloseBtn, "keydown", (e) => {
        if (e.key === "Enter") {
          closeVideoModal();
        }
      });
    !!videoPopupCloseBtn &&
      $on(document, "keydown", (e) => {
        if (e.key === "Escape") {
          closeVideoModal();
        }
      });
  };

  const graphStatsAniamtion = (graphSVG, region_id) => {
    let graphSVG_stat = qs(`#${region_id}_stat`);
    let timelineObj = null;
    !!graphSVG &&
      $on(graphSVG, "mouseover", (e) => {
        if (e.target.id === region_id || e.target.id === `${region_id}_stat`) {
          graphSVG_stat.style.display = "block";
          if (timelineObj && timelineObj.isActive()) {
            timelineObj.kill();
          }
          timelineObj = gsap
            .timeline({
              delay: 0,
            })
            .to(graphSVG_stat, {
              duration: 0.3,
              ease: "easeInOutQuart",
              opacity: 1,
            });
        }
      });

    !!graphSVG &&
      $on(graphSVG, "mouseout", (e) => {
        if (e.target.id === region_id || e.target.id === `${region_id}_stat`) {
          if (
            graphSVG_stat.matches(":hover") ||
            qs(`#${region_id}`).matches(":hover")
          ) {
            return;
          }
          if (timelineObj && timelineObj.isActive()) {
            timelineObj.kill();
          }

          timelineObj = gsap
            .timeline({
              delay: 0,
            })
            .to(graphSVG_stat, {
              duration: 0.3,
              ease: "easeInOutQuart",
              opacity: 0,
            })
            .set(graphSVG_stat, { display: "none" });
        }
      });
  };

  const theNumbersAnimation = () => {
    setTimeout(() => {
      animateTextsByWords();
      let animateBlock = qsa(".animate-block");
      //
      let animateComplaints = qs(".animate-complaints");
      let animate2021Revenue = qs(".animate-2021-revenue");
      let animate2021Expenditures = qs(".animate-2021-expenditures");
      let animate2021rev1 = qs(".animate-2021-rev-1");
      let animate2021rev2 = qs(".animate-2021-rev-2");
      let animate2021rev3 = qs(".animate-2021-rev-3");
      let animate2021rev4 = qs(".animate-2021-rev-4");
      let animate2021rev5 = qs(".animate-2021-rev-5");
      let animate2021rev6 = qs(".animate-2021-rev-6");
      let animate2021rev7 = qs(".animate-2021-rev-7");
      let animate2021rev8 = qs(".animate-2021-rev-8");
      let animate2021rev9 = qs(".animate-2021-rev-9");

      animateNumber(animateComplaints, 4711, true);
      animateNumber(animate2021Revenue, 206413174, true);
      animateNumber(animate2021Expenditures, 195345318, true);
      animateNumber(animate2021rev1, 105581725, true);
      animateNumber(animate2021rev2, 56376275, true);
      animateNumber(animate2021rev3, 39778798, true);
      animateNumber(animate2021rev4, 3612624, true);
      animateNumber(animate2021rev5, 1063752, true);
      animateNumber(animate2021rev6, 84506530, true);
      animateNumber(animate2021rev7, 78508161, true);
      animateNumber(animate2021rev8, 28828722, true);
      animateNumber(animate2021rev9, 3501905, true);

      //graph hover animation
      let graphSVG = qs(".contains-graph-1");
      graphStatsAniamtion(graphSVG, "graph-img-1-1");
      graphStatsAniamtion(graphSVG, "graph-img-1-2");

      let graphSVG2 = qs(".contains-graph-2");
      graphStatsAniamtion(graphSVG2, "graph-img-2-1");
      graphStatsAniamtion(graphSVG2, "graph-img-2-2");
      graphStatsAniamtion(graphSVG2, "graph-img-2-3");
      graphStatsAniamtion(graphSVG2, "graph-img-2-4");
      graphStatsAniamtion(graphSVG2, "graph-img-2-5");
      graphStatsAniamtion(graphSVG2, "graph-img-2-6");

      let graphSVG3 = qs(".contains-graph-3");
      graphStatsAniamtion(graphSVG3, "graph-img-3-1");
      graphStatsAniamtion(graphSVG3, "graph-img-3-2");
      graphStatsAniamtion(graphSVG3, "graph-img-3-3");
      graphStatsAniamtion(graphSVG3, "graph-img-3-4");
      graphStatsAniamtion(graphSVG3, "graph-img-3-5");
      graphStatsAniamtion(graphSVG3, "graph-img-3-6");
      graphStatsAniamtion(graphSVG3, "graph-img-3-7");

      let graphSVG4 = qs(".contains-graph-4");
      graphStatsAniamtion(graphSVG4, "graph-img-4-1");
      graphStatsAniamtion(graphSVG4, "graph-img-4-2");
      graphStatsAniamtion(graphSVG4, "graph-img-4-3");
      graphStatsAniamtion(graphSVG4, "graph-img-4-4");
      graphStatsAniamtion(graphSVG4, "graph-img-4-5");

      let graphSVG5 = qs(".contains-graph-5");
      graphStatsAniamtion(graphSVG5, "graph-img-5-1");
      graphStatsAniamtion(graphSVG5, "graph-img-5-2");
      graphStatsAniamtion(graphSVG5, "graph-img-5-3");
      graphStatsAniamtion(graphSVG5, "graph-img-5-4");

      animateBlock.forEach((elem) => {
        gsap
          .timeline({
            delay: 0,
            scrollTrigger: {
              trigger: elem,
              start: "top bottom",
              ...scrollerParam,
            },
          })
          .to(elem, {
            duration: 0.6,
            y: 0,
          })
          .to(
            elem,
            {
              duration: 0.6,
              opacity: 1,
            },
            "-=0.2"
          );
      });

      qsa(".contains-graph > svg.anim-overlay").forEach((elem) => {
        gsap
          .timeline({
            delay: 0,
            scrollTrigger: {
              trigger: elem,
              start: "top bottom",
              ...scrollerParam,
            },
          })
          .to(elem, {
            strokeDasharray: "0 1715",
          })
          .to(elem, { delay: 2, display: "none" });
      });

      const makeChildVisible = (i) => {
        if (!qsa(".bar-animation")[i]) return;
        let allTextTobeVisible = qsa(".bar-animation")[i].querySelectorAll(
          ".bar-animation-text"
        );
        for (let i = 0; i < allTextTobeVisible.length; i++) {
          if (allTextTobeVisible[i].classList.contains("bar-animation-text")) {
            allTextTobeVisible[i].style.opacity = 1;
          }
        }
      };

      qsa(".bar-animation").forEach((elem, i) => {
        gsap
          .timeline({
            delay: 0,
            onComplete: () => {
              makeChildVisible(i);
            },
            scrollTrigger: {
              trigger: elem,
              start: "top bottom",
              ...scrollerParam,
            },
          })
          .to(elem, {
            flex: "1 1",
          })
          .to(elem, { delay: 1, overflow: "visible" });
      });

      if (!!scroll) {
        scroll.update();
      }
    }, 150);
    animateFooter();
  };

  const stateCapitolAnimation = () => {
    setTimeout(() => {
      animateTextsByWords();

      let animate75 = qs(".animate-75");
      let animate30 = qs(".animate-30");

      animateNumber(animate75, 75);
      animateNumber(animate30, 30);

      if (!!scroll) {
        scroll.update();
      }
    }, 50);
    animateFooter();
  };

  const airDistrictAnimation = () => {
    setTimeout(() => {
      animateTextsByWords();
      if (!!scroll) {
        scroll.update();
      }
    }, 50);
    animateFooter();
  };

  const contactAnimation = () => {
    setTimeout(() => {
      let animateBlock = qsa(".animate-block");
      animateBlock.forEach((elem) => {
        gsap
          .timeline({
            delay: 0,
            scrollTrigger: {
              trigger: elem,
              start: "top 90%",
              ...scrollerParam,
            },
          })
          .to(elem, {
            duration: 0.6,
            y: 0,
          })
          .to(
            elem,
            {
              duration: 0.6,
              opacity: 1,
            },
            "-=0.2"
          );
      });
      animateTextsByWords();
      if (!!scroll) {
        scroll.update();
      }
    }, 50);
    animateFooter();
  };

  const openVideoModal = (src) => {
    let videoContainer = qs(".youtube-video-popup");
    let iframe = qs(".youtube-video-popup iframe");
    videoContainer.style.display = "block";
    iframe.setAttribute("src", src);
  };

  const closeVideoModal = () => {
    let videoContainer = qs(".youtube-video-popup");
    let iframe = qs(".youtube-video-popup iframe");
    videoContainer.style.display = "none";
    iframe.setAttribute("src", "");
  };

  const stripsHideAnimation = (namespace = "") => {
    if (!!menuStripHideTimeline && menuStripHideTimeline.isActive()) {
      return;
    }
    if (
      getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
      getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
    ) {
      if (
        colorStripesMobile.classList.contains("below-menu") &&
        burgerMenu.classList.contains("active")
      ) {
        gsap
          .timeline({})
          .set(qs("body"), { maxHeight: "none", overflow: "auto" })
          .to(colorStripesMobile, {
            delay: 0.45,
            duration: 0.3,
            opacity: 0,
          })
          .set(colorStripesMobile, { display: "none" });
      } else if (!burgerMenu.classList.contains("active")) {
        gsap
          .timeline({})
          .set(qs("body"), { maxHeight: "none", overflow: "auto" })
          .to(colorStripesMobile, {
            delay: 0,
            duration: 0.1,
            opacity: 0,
          })
          .set(colorStripesMobile, { display: "none" });
      }
    } else {
      if (namespace === "executive-officer-statement") {
        otherStips = qsa(".color-strip:not(.bg-color-cyan)");
        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(cyanStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              executiveOfficerAnimations();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "monitoring-sites") {
        otherStips = qsa(".color-strip:not(.bg-color-blue)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(blueStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              monitoringSitesAniamtion();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "furthering-community-protections") {
        otherStips = qsa(".color-strip:not(.bg-color-dark-blue)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(darkBlueStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              furtheringCommunityAniamtion();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "forwarding-clean-air-initiatives") {
        otherStips = qsa(".color-strip:not(.bg-color-purple)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(purpleStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              forwardingCleanAirAnimation();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "the-numbers") {
        otherStips = qsa(".color-strip:not(.bg-color-yellow)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(yellowStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              theNumbersAnimation();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "state-capitol") {
        otherStips = qsa(".color-strip:not(.bg-color-orange)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(orangeStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              stateCapitolAnimation();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "air-district") {
        otherStips = qsa(".color-strip:not(.bg-color-red)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(redStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              airDistrictAnimation();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else if (namespace === "contact") {
        otherStips = qsa(".color-strip:not(.bg-color-cream)");

        isDesktopMenuStripsHidden = true;
        isDesktopMenuStripsWasHidden = true;
        menuStripHideTimeline = gsap
          .timeline({})
          .set(container, { width: "100vw" })
          .to(creamStrip, {
            duration: 0,
            width: "100vw",
          })
          .to(
            otherStips,
            {
              duration: 0.4,
              width: "0vw",
              stagger: 0.05,
            },
            "-=0.5"
          )
          .set(container, {
            left: "0",
            right: "auto",
          })
          .to(container, {
            duration: 0.7,
            width: "0%",
            ease: "SlowMo",
            onComplete: () => {
              contactAnimation();
            },
          })
          .set(container, {
            duration: 0,
            left: "auto",
            right: "0",
          })
          .set(allStips, {
            duration: 0,
            width: "0vw",
          });
      } else {
        if (isDesktopMenuStripsWasHidden) {
          isDesktopMenuStripsHidden = true;
          gsap
            .timeline({})
            .to(allStips, {
              duration: 0.1,
              width: `0vw`,
              stagger: -0.05,
            })
            .set(container, { width: "0vw" });
        }
      }
    }
  };

  const stripsShowAniation = (duration = false) => {
    if (
      getDeviceType() === CONSTANTS.DEVICE_TYPES.MOBILE ||
      getDeviceType() === CONSTANTS.DEVICE_TYPES.TABLET
    ) {
      let urlArray = window.location.href.split("/");

      if (
        colorStripesMobile.classList.contains("below-menu") &&
        !(
          urlArray.length === 3 ||
          !urlArray[3] ||
          urlArray[3] === "#" ||
          urlArray[3] === "index.html"
        )
      ) {
        gsap
          .timeline({})
          .set(colorStripesMobile, { opacity: 0 })
          .set(colorStripesMobile, { display: "flex" })
          .set(qs("body"), { maxHeight: "200vw", overflow: "hidden" })
          .to(colorStripesMobile, {
            duration: duration === 0 ? 0 : 0.5,
            opacity: 1,
          });
      } else if (
        urlArray.length === 3 ||
        !urlArray[3] ||
        urlArray[3] === "#" ||
        urlArray[3] === "index.html"
      ) {
        gsap.set(qs("body"), { maxHeight: "none", overflow: "auto" });
      }
    } else {
      if (isDesktopMenuStripsHidden) {
        isDesktopMenuStripsHidden = false;
        gsap
          .timeline({})
          .set(allStips, { width: "0vw" })
          .set(container, { width: "40vw" })
          .to(allStips, {
            duration: duration === 0 ? 0 : 0.3,
            width: (i) => `${(8 - i) * 5}vw`,
            stagger: duration === 0 ? 0.0001 : 0.15,
          });
      }
    }
  };

  //on resize reload
  let windowWidth = window.innerWidth;
  let debouncedRelaod = debounce(function () {
    if (windowWidth !== window.innerWidth) {
      windowWidth = window.innerWidth;
      location.reload();
    }
  }, 1000);
  window.onresize = debouncedRelaod;
};

onWindowLoad(init);
